
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Pack} from '@/lib/Pack';
    import {PackGuarantee} from '@/lib/PackGuarantee';

    @Component({})
    export default class PackView extends Vue {
        @Prop() public pack: Pack;
        saveOrder(){
            console.log('clicked');
            this.$store.dispatch('saveOrder', { pack: this.pack, responseGroupId: this.$route.params.responseGroupId});
        }
        get brokenGlass(){
            return this.pack.guarantees.some((packGuarantee: PackGuarantee) => packGuarantee.guarantee.id === 6);
        }
        get defense(){
            return this.pack.guarantees.some((packGuarantee: PackGuarantee) => packGuarantee.guarantee.id === 2);
        }
    }
